"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const jsx_runtime_1 = require("react/jsx-runtime");
const react_1 = require("react");
const ClickableTextWeb_1 = __importDefault(require("./ClickableTextWeb"));
const ButtonWeb_1 = __importDefault(require("./ButtonWeb"));
const native_1 = require("@react-navigation/native");
const images_1 = require("../../services/images");
const react_redux_1 = require("react-redux");
const selectors_1 = require("../../store/redux/selectors");
const dictionaries_1 = require("../../services/dictionaries");
const react_i18next_1 = require("react-i18next");
const message_1 = require("../../store/redux/message");
const flightHandlers_1 = require("../../handlers/flightHandlers");
const NavigationWrapperWeb = (props) => {
    const isAuthenticated = (0, react_redux_1.useSelector)(selectors_1.getIsAuthenticated);
    const newUser = isAuthenticated && (0, react_redux_1.useSelector)(selectors_1.getUser);
    const [hoveredStack, setHoveredStack] = (0, react_1.useState)(null);
    const route = (0, native_1.useRoute)();
    const navigation = (0, native_1.useNavigation)();
    const [t] = (0, react_i18next_1.useTranslation)("i18n", { keyPrefix: 'landing_page.navigation' });
    const userDetails = isAuthenticated ? (0, react_redux_1.useSelector)(selectors_1.getUser) : null;
    const chats = (0, react_redux_1.useSelector)(selectors_1.getAllChats);
    const dispatch = (0, react_redux_1.useDispatch)();
    const flightsCounter = (0, react_redux_1.useSelector)(selectors_1.getMyFlightsNotificationCount);
    (0, react_1.useEffect)(() => {
        (0, flightHandlers_1.refreshNotificationsHandler)(isAuthenticated);
    }, []);
    (0, react_1.useEffect)(() => {
        (0, flightHandlers_1.refreshNotificationsWithIntervalHandler)(isAuthenticated);
    }, []);
    const messagesNotification = () => {
        let messagesNotificationCounter = 0;
        if (chats)
            chats.forEach((chat) => {
                if (!chat.last_message?.read_timestamp && userDetails?.id != chat.last_message?.sender?.id) {
                    messagesNotificationCounter++;
                }
            });
        return messagesNotificationCounter;
    };
    const renderButtonsNonAuthenticated = () => ((0, jsx_runtime_1.jsxs)(jsx_runtime_1.Fragment, { children: [(0, jsx_runtime_1.jsx)(ClickableTextWeb_1.default, { onClick: () => navigation.replace("LogIn"), style: { marginRight: 40 }, children: t("login") }), (0, jsx_runtime_1.jsx)(ButtonWeb_1.default, { onClick: () => navigation.replace("SignUp"), type: "Blue", children: t("register") })] }));
    const renderButtonsAuthenticated = () => {
        let counterElement;
        const messageCounter = messagesNotification();
        const showCounter = (counter) => {
            if (counter) {
                counterElement = (0, jsx_runtime_1.jsx)("div", { className: "counter-background", children: (0, jsx_runtime_1.jsx)("div", { className: "counter", children: counter > 99 ? `+99` : counter }) });
            }
            else {
                counterElement = (0, jsx_runtime_1.jsx)(jsx_runtime_1.Fragment, {});
            }
            return counterElement;
        };
        const renderButton = (stack, screen, title, icon, counter, className) => {
            const active = stack === hoveredStack || dictionaries_1.stackScreens[stack]?.includes(route.name);
            return ((0, jsx_runtime_1.jsxs)("div", { onMouseEnter: () => setHoveredStack(stack), onMouseLeave: () => setHoveredStack(null), onClick: () => {
                    dispatch((0, message_1.setCurrentChat)([]));
                    navigation.navigate(screen);
                }, className: className, children: [(0, jsx_runtime_1.jsx)("img", { src: icon, alt: title }), (0, jsx_runtime_1.jsx)("span", { className: `clickable-text smooth ${active ? 'active' : ''}`, children: title }), showCounter(counter)] }));
        };
        return ((0, jsx_runtime_1.jsxs)("div", { className: "authenticated-nav-container", children: [renderButton("HomeStack", "Home", t("fly"), images_1.icons.LetsFlyMenuActive, 0), renderButton("MyFlightsStack", "MyFlights", t("flights"), images_1.icons.MyFlightsMenuActive, flightsCounter), renderButton("MessagesStack", "Messages", t("messages"), images_1.icons.MessagesMenuActive, messageCounter), renderButton("AccountStack", "Account", t("account"), images_1.icons.AccountMenuActive, 0, "show-mobile"), " ", (0, jsx_runtime_1.jsx)("img", { className: "photo", onClick: () => navigation.navigate("Account"), src: userDetails?.image_path ? `${images_1.cloudFrontUrlAvatars + userDetails.image_path}` : images_1.icons.DefaultUser, alt: "User" })] }));
    };
    (0, react_1.useEffect)(() => {
        window.scrollTo(0, 0);
    }, []);
    return (!isAuthenticated ?
        (0, jsx_runtime_1.jsxs)("div", { className: "page", style: {}, children: [(0, jsx_runtime_1.jsxs)("div", { className: "navbar", children: [(0, jsx_runtime_1.jsx)("img", { alt: "flyway-logo", className: "logo", src: images_1.images.logoHorizontal, onClick: () => navigation.navigate("LandingPage") }), !props.email_verified && (0, jsx_runtime_1.jsx)("div", { className: "buttons-container", children: newUser ? renderButtonsAuthenticated() : renderButtonsNonAuthenticated() })] }), (0, jsx_runtime_1.jsx)("div", { className: "page-container unauthorized", children: props.children })] }) :
        (0, jsx_runtime_1.jsxs)("div", { className: "page", style: {
                backgroundColor: '#fff',
            }, children: [(0, jsx_runtime_1.jsxs)("div", { className: "navbar", style: {
                        backgroundImage: `url(${images_1.images.cloud})`,
                        backgroundRepeat: 'no-repeat',
                        backgroundSize: 'cover',
                        backgroundPosition: 'top -200px',
                    }, children: [(0, jsx_runtime_1.jsx)("img", { alt: "flyway-logo", className: "logo", src: images_1.images.logoHorizontal, onClick: () => navigation.navigate("LandingPage") }), (0, jsx_runtime_1.jsx)("div", { className: "buttons-container", children: renderButtonsAuthenticated() })] }), (0, jsx_runtime_1.jsx)("div", { className: "page-container", children: props.children })] }));
};
exports.default = NavigationWrapperWeb;
